import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, Phone, User, ArrowRight } from 'lucide-react';
import { cn } from '../utils/cn';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#'
  }, {
    name: 'About',
    href: '#'
  }, {
    name: 'Training Programs',
    href: '#'
  }, {
    name: 'Specialized Training',
    href: '#'
  }, {
    name: 'Resources',
    href: '#'
  }, {
    name: 'Contact',
    href: '#'
  }];
  return <nav className={cn('fixed top-0 left-0 right-0 z-50 transition-all duration-500 px-6 py-4', isScrolled ? 'bg-background/80 backdrop-blur-xl border-b border-white/10' : 'bg-transparent')} data-id="element-259">
      <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-260">
        <div className="flex items-center gap-8" data-id="element-261">
          <a href="/" className="relative z-10" data-id="element-262">
            <img src="https://www.cyberreadysecurity.info/wp-content/themes/cyberreadyip212/images/main-logo.png" alt="CRS Logo" className="h-10 md:h-12 w-auto" data-id="element-263" />
          </a>

          <div className="hidden lg:flex items-center gap-6" data-id="element-264">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-white/70 hover:text-primary-blue transition-colors" data-id="element-265">
                {link.name}
              </a>)}
          </div>
        </div>

        <div className="hidden lg:flex items-center gap-4" data-id="element-266">
          <a href="tel:+1234567890" className="flex items-center gap-2 text-white/70 hover:text-white transition-colors text-sm" data-id="element-267">
            <Phone size={16} data-id="element-268" />
            <span data-id="element-269">(800) 123-4567</span>
          </a>
          <button className="flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 text-sm font-medium text-white hover:bg-white/10 transition-colors" data-id="element-270">
            <User size={16} data-id="element-271" />
            Student Portal
          </button>
          <button className="px-6 py-2 rounded-full bg-primary-blue text-sm font-bold text-white hover:bg-blue-600 transition-all shadow-lg shadow-primary-blue/20" data-id="element-272">
            Apply Now
          </button>
        </div>

        <button className="lg:hidden text-white" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-273">
          {isMobileMenuOpen ? <X size={28} data-id="element-274" /> : <Menu size={28} data-id="element-275" />}
        </button>
      </div>

      <AnimatePresence data-id="element-276">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="lg:hidden bg-background/95 backdrop-blur-2xl border-b border-white/10 overflow-hidden" data-id="element-277">
            <div className="flex flex-col p-6 gap-4" data-id="element-278">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-lg font-medium text-white/70 hover:text-primary-blue py-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-279">
                  {link.name}
                </a>)}
              <hr className="border-white/10 my-2" data-id="element-280" />
              <button className="w-full py-3 rounded-xl bg-white/5 border border-white/10 text-white font-medium" data-id="element-281">
                Student Portal
              </button>
              <button className="w-full py-3 rounded-xl bg-primary-blue text-white font-bold" data-id="element-282">
                Apply Now
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}